// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aws-compliance[data-v-d5d708ce]{background-color:var(--error);color:var(--error-text);line-height:2em;width:100%}.aws-compliance[data-v-d5d708ce],.aws-compliance>p[data-v-d5d708ce]{text-align:center}", ""]);
// Exports
module.exports = exports;
